<app-header></app-header>

<div class="page-title-area page-title-style-two despre-bg">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Situatie drepturi salariale</li>
            </ul>
            <h2>Situatie drepturi salariale</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-content left-content">
                    <span class="sub-title">Situatie drepturi salariale</span>
                    <p>
                        Acceseaza<a
                            href="../../../assets/img/pdf/09 30 2022_CMDTAMP Bucuresti_Transparenta venituri.pdf"
                            download
                        >
                            aici</a
                        >
                        situatia salariala la nivelul clinicii CMDTAMP
                    </p>
                    <p>
                        Acceseaza
                        <a
                            href="../../../assets/img/pdf/03 31 2023_CMDTAMP Bucuresti_Transparenta venituri.pdf"
                            download
                            >aici</a
                        >
                        situatia salariala la nivelul clinicii CMDTAMP - martie
                        2023
                    </p>
                    <p>
                        Acceseaza
                        <a
                            href="../../../assets/img/pdf/09 30 2023_CMDTAMP Bucuresti_Transparenta venituri.pdf"
                            download
                            >aici</a
                        >
                        situatia salariala la nivelul clinicii CMDTAMP -
                        octombrie 2023
                    </p>
                    <p>
                        Acceseaza<a
                            href="../../../assets/img/pdf/03 31 2024_CMDTAMP Bucuresti_Transparenta venituri.pdf"
                            download
                        >
                            aici</a
                        >
                        situatia salariala la nivelul clinicii CMDTAMP – Aprilie
                        2024
                    </p>
                    <p>
                        Acceseaza<a
                            href="../../../assets/img/pdf/09 30 2024_CMDTAMP Bucuresti_Transparenta venituri.pdf"
                            download
                        >
                            aici</a
                        >
                        situatia salariala la nivelul clinicii CMDTAMP –
                        Septembrie 2024
                    </p>
                    <p>
                        Acceseaza<a
                            href="../../../assets/img/pdf/03 31 2025_CMDTAMP Bucuresti_Transparenta venituri.pdf"
                            download
                        >
                            aici</a
                        >
                        situatia salariala la nivelul clinicii CMDTAMP – Martie
                        2025
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
